import React from 'react'
import { useMediaQuery} from "@mui/material"

import NavBar from '../Components/NavBar'
import Banner from '../Components/Banner'
import Footer from '../Components/Footer'
import ServiceList from '../Components/ServiceList'
import Container from 'react-bootstrap/Container'
import {BsArrowRightCircleFill} from 'react-icons/bs'


const TechnicalService = () => {
  const isMobileScreen = useMediaQuery("(max-width: 991px)");

  return (
    <div>
      <Banner />
     <NavBar />
     <div className='position-relative overflow-hidden'>
      <img src="/assests/images/technical-services.jpg" alt="Image" width={1500} height={300} style={{
        objectFit: "cover",
        filter: "brightness(50%)",
      }}/>
      <div className='position-absolute' style={{
      left: isMobileScreen ? "15%" : "35%",
        top: "40%"
      }}>
      <h1 className='text-light' style={{
      fontSize: isMobileScreen ? "1.5rem" : "3rem"
    }}>Services / Technical</h1>
      </div>
     </div>
     <Container className='my-5'>
        <div className="row">
          <div className="col-3" style={{
          display: isMobileScreen ? "none" : "block"
        }}>
<ServiceList />
          </div>
          <div className="col-lg-9 col-12 justify-content-center">
            <div>
            <div className='d-flex flex-wrap gap-3'>
              <div>
              <img src='/assests/images/v35.jpg' alt='light-1' width="350"/>
<p className='fs-5 text-center'>AC Interference Study
</p>
              </div>
              <div>
              <img src='/assests/images/light-2.jpg' alt='light-3' width="400"/>
              <p className='fs-5 text-center'>Lightning Protection 
Adequacy Study and Design</p>
</div>
            </div>
              <div className='d-flex flex-wrap gap-3'>
                <div>
              <img src='/assests/images/v34.gif' alt='light-1' width="350"/>
              <p className='fs-5 text-center'>Power Quality Study and Audit
</p>
              </div>
              <div>
              <img src='/assests/images/v22.jpg' alt='v34.jpg' width="400"/>
              <p className='fs-5 text-center'>Earthing System Health 
Assessment and Design</p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </Container>
    <Footer />
    </div>
  )
}

export default TechnicalService


